"use client";

import { useState } from "react";
import DesktopMenu from "./DesktopMenu";
import MobileMenu from "./MobileMenu";
import Logo from "./Logo";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed left-0 top-0 z-[80] w-full border-b border-white/10 bg-[#082f49] text-white shadow-[0_10px_32px_rgba(8,47,73,0.24)]">

      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-5 py-2 sm:px-8 lg:px-10">
        <Logo />

        <div className="hidden md:block">
          <DesktopMenu />
        </div>

        <MobileMenu isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>
    </nav>
  );
}

export default Navbar;
